import { useSelector } from 'react-redux'
import type { RootState } from '@/store'

import { resolveBusinessTimezone } from '@/utils/businessDay'
/**
 * 获取当前用户的时区设置
 * @returns 用户时区（IANA 格式），默认为 'America/New_York' (EST)
 */
export const useUserTimezone = (): string => {
  const timezone = useSelector((state: RootState) => state.user.timezone)

  // 2026-10-31 起用户时区必填；为空 / 不认识时回落平台时区（与后端 sys.fallback_timezone 同值），不看浏览器时区
  return resolveBusinessTimezone(timezone)
}

/**
 * 获取用户时区的详细信息
 * @returns 包含时区和是否使用默认值的对象
 */
export const useUserTimezoneInfo = () => {
  const timezone = useSelector((state: RootState) => state.user.timezone)
  
  return {
    timezone: resolveBusinessTimezone(timezone),
    isDefault: !timezone,
  }
}